import { Dispatch } from "../store.config"

import axios from "axios"
import { AnyAction } from "redux"
import { FiduciaryCaptureMail } from "../../utils/captureMail"

const enum CaptureActionsEnum {
  ADD_CAPTURE_MAIL_SUCCESS = "CAPTURE/addCaptureMailSuccess",
  ADD_CAPTURE_MAIL_FAILURE = "CAPTURE/addCaptureMailFailure",
  ADD_CAPTURE_MAIL_REACTIVATION = "CAPTURE/addCaptureMailReactivation",
  ADD_CAPTURE_MAIL_EMAIL_USED = "CAPTURE/addCaptureMailEmailUsed",
  ADD_CAPTURE_MAIL_RESET = "CAPTURE/addCaptureMailReset",
  GET_CAPTURE_MAIL_ENTITIES_ATTEMPT = "CAPTURE/getCaptureMailEntitiesAttempt",
  GET_CAPTURE_MAIL_ENTITIES_SUCCESS = "CAPTURE/getCaptureMailEntitiesSuccess",
  GET_CAPTURE_MAIL_ENTITIES_FAILURE = "CAPTURE/getCaptureMailEntitiesFailure",
  DELETE_CAPTURE_MAIL_USER_SUCCESS = "CAPTURE/deleteCaptureMailEntitySuccess",
  DELETE_CAPTURE_MAIL_USER_FAILURE = "CAPTURE/deleteCaptureMailEntityFailure",
  DELETE_CAPTURE_MAIL_USER_RESET = "CAPTURE/deleteCaptureMailEntityResetAction",
  GET_FIDUCIARY_CAPTURE_MAILS_ATTEMPT = "CAPTURE/getFiduciaryCaptureMailAttempt",
  GET_FIDUCIARY_CAPTURE_MAILS_SUCCESS = "CAPTURE/getFiduciaryCaptureMailSuccess",
  GET_FIDUCIARY_CAPTURE_MAILS_FAILURE = "CAPTURE/getFiduciaryCaptureMailFailure",
  DOWNLOAD_FIDUCIARY_CAPTURE_MAILS_CSV_ATTEMPT = "CAPTURE/downloadFiduciaryCaptureMailsCsvAttempt",
  DOWNLOAD_FIDUCIARY_CAPTURE_MAILS_CSV_SUCCESS = "CAPTURE/downloadFiduciaryCaptureMailsCsvSuccess",
  DOWNLOAD_FIDUCIARY_CAPTURE_MAILS_CSV_FAILURE = "CAPTURE/downloadFiduciaryCaptureMailsCsvFailure",
}

export const addCaptureMailSuccessAction = () =>
  ({
    type: CaptureActionsEnum.ADD_CAPTURE_MAIL_SUCCESS,
    withToast: true,
    toasterType: "success",
    message: {
      titleKey: "capture-mail.toaster.title",
      bodyKey: "capture-mail.addition.success",
    },
  } as const)
export const addCaptureMailFailureAction = () =>
  ({ type: CaptureActionsEnum.ADD_CAPTURE_MAIL_FAILURE } as const)
export const addCaptureMailReactivationAction = () =>
  ({ type: CaptureActionsEnum.ADD_CAPTURE_MAIL_REACTIVATION } as const)
export const addCaptureMailEmailUsedAction = (error: string) =>
  ({
    type: CaptureActionsEnum.ADD_CAPTURE_MAIL_EMAIL_USED,
    withToast: true,
    toasterType: "error",
    message: {
      titleKey: "capture-mail.toast.error.title",
      bodyKey: error,
    },
  } as const)
export const addCaptureMailResetAction = () =>
  ({ type: CaptureActionsEnum.ADD_CAPTURE_MAIL_RESET } as const)
export const getCaptureMailEntitiesAttemptAction = () =>
  ({ type: CaptureActionsEnum.GET_CAPTURE_MAIL_ENTITIES_ATTEMPT } as const)
export const getCaptureMailEntitiesSuccessAction = (
  payload: CaptureMailEntities[]
) =>
  ({
    type: CaptureActionsEnum.GET_CAPTURE_MAIL_ENTITIES_SUCCESS,
    payload,
  } as const)
export const getCaptureMailEntitiesFailureAction = () =>
  ({ type: CaptureActionsEnum.GET_CAPTURE_MAIL_ENTITIES_FAILURE } as const)

export const deleteCaptureMailEntitySuccessAction = () =>
  ({
    type: CaptureActionsEnum.DELETE_CAPTURE_MAIL_USER_SUCCESS,
    withToast: true,
    toasterType: "success",
    message: {
      titleKey: "capture-mail.toaster.title",
      bodyKey: "capture-mail.removal.success",
    },
  } as const)
export const deleteCaptureMailEntityFailureAction = () =>
  ({ type: CaptureActionsEnum.DELETE_CAPTURE_MAIL_USER_FAILURE } as const)
export const deleteCaptureMailEntityResetAction = () =>
  ({ type: CaptureActionsEnum.DELETE_CAPTURE_MAIL_USER_RESET } as const)

export const getFiduciaryCaptureMailAttemptAction = () =>
  ({ type: CaptureActionsEnum.GET_FIDUCIARY_CAPTURE_MAILS_ATTEMPT } as const)
export const getFiduciaryCaptureMailSuccessAction = (
  payload: FiduciaryCaptureMail[]
) =>
  ({
    type: CaptureActionsEnum.GET_FIDUCIARY_CAPTURE_MAILS_SUCCESS,
    payload,
  } as const)
export const getFiduciaryCaptureMailFailureAction = () =>
  ({ type: CaptureActionsEnum.GET_FIDUCIARY_CAPTURE_MAILS_FAILURE } as const)

export const downloadFiduciaryCaptureMailsCsvAttemptAction = () =>
  ({
    type: CaptureActionsEnum.DOWNLOAD_FIDUCIARY_CAPTURE_MAILS_CSV_ATTEMPT,
  } as const)
export const downloadFiduciaryCaptureMailsCsvSuccessAction = () =>
  ({
    type: CaptureActionsEnum.DOWNLOAD_FIDUCIARY_CAPTURE_MAILS_CSV_SUCCESS,
  } as const)
export const downloadFiduciaryCaptureMailsCsvFailureAction = () =>
  ({
    type: CaptureActionsEnum.DOWNLOAD_FIDUCIARY_CAPTURE_MAILS_CSV_FAILURE,
  } as const)

type CaptureActionsType = ReturnType<
  | typeof addCaptureMailSuccessAction
  | typeof addCaptureMailFailureAction
  | typeof addCaptureMailReactivationAction
  | typeof addCaptureMailEmailUsedAction
  | typeof addCaptureMailResetAction
  | typeof getCaptureMailEntitiesAttemptAction
  | typeof getCaptureMailEntitiesSuccessAction
  | typeof getCaptureMailEntitiesFailureAction
  | typeof deleteCaptureMailEntitySuccessAction
  | typeof deleteCaptureMailEntityFailureAction
  | typeof deleteCaptureMailEntityResetAction
  | typeof getFiduciaryCaptureMailAttemptAction
  | typeof getFiduciaryCaptureMailSuccessAction
  | typeof getFiduciaryCaptureMailFailureAction
  | typeof downloadFiduciaryCaptureMailsCsvAttemptAction
  | typeof downloadFiduciaryCaptureMailsCsvSuccessAction
  | typeof downloadFiduciaryCaptureMailsCsvFailureAction
>

export interface CaptureState {
  captureMailStatus:
    | "UNSET"
    | "SUCCESS"
    | "ERROR"
    | "REACTIVATED"
    | "EMAIL_USED"
  captureMailEntities: CaptureMailEntities[]
  deleteCaptureMailEntitiesStatus: "UNSET" | "SUCCESS" | "ERROR"
  fiduciaryCaptureMails: FiduciaryCaptureMail[]
  getFiduciaryCaptureMailsStatus: "IDLE" | "LOADING" | "SUCCESS" | "ERROR"
  downloadFiduciaryCaptureMailsCsvStatus:
    | "IDLE"
    | "LOADING"
    | "SUCCESS"
    | "ERROR"
}

export const captureInitialState: CaptureState = {
  captureMailStatus: "UNSET",
  captureMailEntities: [],
  deleteCaptureMailEntitiesStatus: "UNSET",
  fiduciaryCaptureMails: [],
  getFiduciaryCaptureMailsStatus: "IDLE",
  downloadFiduciaryCaptureMailsCsvStatus: "IDLE",
}

export function captureReducer(
  state = captureInitialState,
  action: CaptureActionsType
): CaptureState {
  switch (action.type) {
    case CaptureActionsEnum.ADD_CAPTURE_MAIL_SUCCESS:
      return { ...state, captureMailStatus: "SUCCESS" }
    case CaptureActionsEnum.ADD_CAPTURE_MAIL_FAILURE:
      return { ...state, captureMailStatus: "ERROR" }
    case CaptureActionsEnum.ADD_CAPTURE_MAIL_REACTIVATION:
      return { ...state, captureMailStatus: "REACTIVATED" }
    case CaptureActionsEnum.ADD_CAPTURE_MAIL_EMAIL_USED:
      return { ...state, captureMailStatus: "EMAIL_USED" }
    case CaptureActionsEnum.ADD_CAPTURE_MAIL_RESET:
      return { ...state, captureMailStatus: "UNSET" }
    case CaptureActionsEnum.GET_CAPTURE_MAIL_ENTITIES_SUCCESS:
      return { ...state, captureMailEntities: action.payload }
    case CaptureActionsEnum.DELETE_CAPTURE_MAIL_USER_SUCCESS:
      return { ...state, deleteCaptureMailEntitiesStatus: "SUCCESS" }
    case CaptureActionsEnum.DELETE_CAPTURE_MAIL_USER_FAILURE:
      return { ...state, deleteCaptureMailEntitiesStatus: "ERROR" }
    case CaptureActionsEnum.DELETE_CAPTURE_MAIL_USER_RESET:
      return { ...state, deleteCaptureMailEntitiesStatus: "UNSET" }
    case CaptureActionsEnum.GET_FIDUCIARY_CAPTURE_MAILS_ATTEMPT:
      return { ...state, getFiduciaryCaptureMailsStatus: "LOADING" }
    case CaptureActionsEnum.GET_FIDUCIARY_CAPTURE_MAILS_SUCCESS:
      return {
        ...state,
        getFiduciaryCaptureMailsStatus: "SUCCESS",
        fiduciaryCaptureMails: action.payload,
      }
    case CaptureActionsEnum.GET_FIDUCIARY_CAPTURE_MAILS_FAILURE:
      return { ...state, getFiduciaryCaptureMailsStatus: "ERROR" }
    case CaptureActionsEnum.DOWNLOAD_FIDUCIARY_CAPTURE_MAILS_CSV_ATTEMPT:
      return { ...state, downloadFiduciaryCaptureMailsCsvStatus: "LOADING" }
    case CaptureActionsEnum.DOWNLOAD_FIDUCIARY_CAPTURE_MAILS_CSV_SUCCESS:
      return { ...state, downloadFiduciaryCaptureMailsCsvStatus: "SUCCESS" }
    case CaptureActionsEnum.DOWNLOAD_FIDUCIARY_CAPTURE_MAILS_CSV_FAILURE:
      return { ...state, downloadFiduciaryCaptureMailsCsvStatus: "ERROR" }
    default:
      return { ...state }
  }
}

interface CaptureMailEntities {
  id: number
  denomination: string
  email: string
  is_capture_email: boolean
}

interface CaptureMailEntitiesResponse {
  first_name: string
  last_name: string
  denomination?: string
  id: number
  email: string
  is_capture_email: boolean
}

export interface CaptureMailRegisterPayload {
  email: string
  companyId: number | undefined
}

export const attemptToRegisterCaptureMailEntitiesThunk =
  ({ email, companyId }: CaptureMailRegisterPayload) =>
  (dispatch: Dispatch<CaptureActionsType>) => {
    const data = {
      capture_email: {
        company_id: companyId,
        email: email,
      },
    }
    return axios
      .post(`/companies/${companyId}/capture_emails`, data)
      .then((response) => {
        if (response.data === "User reactivated") {
          dispatch(addCaptureMailReactivationAction())
        } else {
          dispatch(addCaptureMailSuccessAction())
        }
      })
      .catch((e) => {
        if (
          e.response.data.error ===
            "Cet email de capture est déjà enregistré" ||
          e.response.data.error ===
            "Un utilisateur existe déjà avec cet email : désactivez-le si vous souhaitez créer un email d'envoi" ||
          e.response.data.error === "Cet email appartient à une autre company !"
        ) {
          dispatch(addCaptureMailEmailUsedAction(e.response.data.error))
        } else {
          dispatch(addCaptureMailFailureAction())
        }
      })
  }

export const getCaptureMailEntitiesThunk =
  (currendCompanyId: number | null) => (dispatch: Dispatch<AnyAction>) => {
    dispatch(getCaptureMailEntitiesAttemptAction())
    return axios
      .get<CaptureMailEntitiesResponse[]>(
        `/companies/${currendCompanyId}/capture_emails`
      )
      .then(({ data }) => {
        const formattedUsers = data.map((user) => ({
          id: user.id,
          denomination: user.denomination
            ? user.denomination
            : user.first_name + " " + user.last_name,
          email: user.email,
          is_capture_email: user.is_capture_email
            ? user.is_capture_email
            : false,
        }))
        dispatch(getCaptureMailEntitiesSuccessAction(formattedUsers))
      })
      .catch(() => {
        dispatch(getCaptureMailEntitiesFailureAction())
      })
  }

export interface CaptureMailDeletePayload {
  id: number
  selectedCompanyId: number | null
}

export const attemptToDeleteCaptureMailEntitiesThunk =
  ({ id, selectedCompanyId }: CaptureMailDeletePayload) =>
  (dispatch: Dispatch<CaptureActionsType>) => {
    return axios
      .delete(`/companies/${selectedCompanyId}/capture_emails/${id}`)
      .then(() => {
        dispatch(deleteCaptureMailEntitySuccessAction())
      })
      .catch(() => {
        dispatch(deleteCaptureMailEntityFailureAction())
      })
  }

export const getFiduciaryCaptureMailsThunk =
  (fiduciaryId: number) =>
  (dispatch: Dispatch<AnyAction | CaptureActionsType>) => {
    dispatch(getFiduciaryCaptureMailAttemptAction())
    return axios
      .get<FiduciaryCaptureMail[]>(
        `/fiduciaries/${fiduciaryId}/get_companies_capture_mails`
      )
      .then((response) => {
        dispatch(getFiduciaryCaptureMailSuccessAction(response.data))
      })
      .catch(() => {
        dispatch(getFiduciaryCaptureMailFailureAction())
      })
  }

export const downloadFiduciaryCaptureMailsCsvThunk =
  (fiduciaryId: number) =>
  (dispatch: Dispatch<AnyAction | CaptureActionsType>) => {
    dispatch(downloadFiduciaryCaptureMailsCsvAttemptAction())
    return axios
      .get(`/fiduciaries/${fiduciaryId}/download_csv_companies_capture_email`, {
        responseType: "blob",
      })
      .then((response) => {
        const blob = response.data as Blob
        let filename = "capture_mail.csv"
        const disposition =
          response.headers &&
          (response.headers["content-disposition"] ||
            response.headers["Content-Disposition"])
        if (disposition) {
          const match = /filename="?([^";]+)"?/i.exec(disposition)
          if (match && match[1]) filename = match[1]
        }
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement("a")
        link.href = url
        link.setAttribute("download", filename)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
        dispatch(downloadFiduciaryCaptureMailsCsvSuccessAction())
      })
      .catch(() => {
        dispatch(downloadFiduciaryCaptureMailsCsvFailureAction())
      })
  }
